export default __webpack_public_path__ + "static/media/light.bb221742.svg";